import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers, ArrowRight } from "lucide-react";
import * as api from "../lib/api";

const PRIMARY = "#018D4C";

// GSC-first: pages built on synced CMS articles show what a CMS unlocks instead of an
// empty table. "Connected" = the onboarding `cms` fact (a cms_connections row or legacy
// Astro settings), so it matches the setup checklist exactly.

// null while loading. If status can't load, report connected so nothing is locked —
// each page already handles its own empty data.
export function useCmsConnected() {
  const [connected, setConnected] = useState(null);

  useEffect(() => {
    let alive = true;
    api.getOnboarding()
      .then(s => alive && setConnected(!!s.steps?.find(st => st.key === "cms")?.done))
      .catch(() => alive && setConnected(true));
    return () => { alive = false; };
  }, []);

  return connected;
}

export default function CmsGate({ feature, description, children }) {
  const connected = useCmsConnected();

  if (connected === null) return null;
  if (connected) return children;

  return (
    <div className="px-6 py-16 max-w-xl mx-auto text-center" data-testid="cms-gate">
      <div className="w-10 h-10 mx-auto mb-4 rounded-xl flex items-center justify-center" style={{ background: "#ECFDF5" }}>
        <Layers size={18} style={{ color: PRIMARY }} />
      </div>
      <h1 className="text-base font-bold text-zinc-900">Connect a CMS to unlock {feature}</h1>
      <p className="text-sm text-zinc-500 mt-2">{description}</p>
      <p className="text-xs text-zinc-400 mt-4">
        Search Performance, search topics, Audience, Query Gaps, Fan-Out, SEO Audit and Reports
        already work with just Search Console.
      </p>
      <div className="flex items-center justify-center gap-3 mt-6">
        <Link
          to="/dashboard/settings/cms"
          className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-bold text-white rounded-lg hover:opacity-90"
          style={{ backgroundColor: PRIMARY }}
        >
          Connect CMS <ArrowRight size={12} />
        </Link>
        <Link to="/dashboard/search-performance" className="text-xs font-bold text-zinc-600 hover:text-zinc-900">
          Back to Search Performance
        </Link>
      </div>
    </div>
  );
}
